// extracted by mini-css-extract-plugin
export default {"title":"PortletTitle__title--3YK","registerTitle":"PortletTitle__registerTitle--_o_"};